/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import {
  createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import global from './reducers/global';
import questions from './reducers/questions';
import steps from './reducers/steps';
import events from './middlewares/events';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({
    global,
    questions,
    steps,
  }),
  composeEnhancers(applyMiddleware(events)),
);

export default store;
